// src/components/AllRealEstate.js
import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";

const Container = styled.div`
  max-width: 900px;
  margin: 2rem auto;
`;

const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Card = styled.div`
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 8px;
  width: 250px;
  position: relative;
  background-color: #fff;
`;

const Preview = styled.img`
  width: 100%;
  border-radius: 4px;
`;

const Checkbox = styled.input`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
`;

const Button = styled.button`
  margin-top: 1.5rem;
  padding: 0.8rem 1.5rem;
  background-color: #e63946;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #c12c3a;
  }
`;

const AllRealEstate = ({ userRealEstate, setUserRealEstate }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const token = localStorage.getItem("token");

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleBulkDelete = async () => {
    try {
      await Promise.all(
        selectedIds.map((id) =>
          axios.delete(
            `/api/AffordableRealestates/${id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          )
        )
      );

      setUserRealEstate((prev) =>
        prev.filter((item) => !selectedIds.includes(item._id))
      );

      setSelectedIds([]);
      alert("Selected real estate deleted.");
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Error deleting real estate.");
    }
  };

  return (
    <Container>
      <h2>My Real Estate Listings</h2>

      <CardList>
        {Array.isArray(userRealEstate) && userRealEstate.length > 0 ? (
          userRealEstate.map((item) => (
            <Card key={item._id}>
              <Checkbox
                type="checkbox"
                checked={selectedIds.includes(item._id)}
                onChange={() => handleCheckboxChange(item._id)}
              />

              <Preview
                src={`/uploads/${item.img}`}
                alt={item.type}
              />

              <h4>{item.type}</h4>
              <p>
                <strong>City:</strong> {item.city}
              </p>
              <p>
                <strong>Store:</strong> {item.storeName}
              </p>
              <p>
                <strong>Mobile:</strong> {item.mobile}
              </p>
              <p>
                <strong>Price:</strong> ${item.price}
              </p>
              <p style={{ fontSize: "0.9rem", color: "#555" }}>
                {item.description}
              </p>
            </Card>
          ))
        ) : (
          <p style={{ marginTop: "1rem", color: "#777" }}>
            🚫 No real estate listings found.
          </p>
        )}
      </CardList>

      {selectedIds.length > 0 && (
        <Button onClick={handleBulkDelete}>
          Delete Selected ({selectedIds.length})
        </Button>
      )}
    </Container>
  );
};

export default AllRealEstate;
